import { TiInfinity } from 'react-icons/ti';

const BLOCK = 'LStudio__app_table';

/*
    🔥 SELECTOR DE REGISTROS POR PÁGINA

    ⚠️ SEGMENTADO, NO UN <select>

    Con cuatro opciones, un select obliga a dos clics —abrir y elegir—
    para algo que se cambia seguido. Botones en línea es un clic, y
    además se ve de un vistazo cuál está activo.

    ⚠️ EL VALOR -1 SIGNIFICA "TODOS"

    Es el infinito de tu versión original. Se usa -1 y no 0 ni null
    porque cero podría confundirse con "ninguno", y null con "sin
    definir". Un número negativo no puede ser una cantidad válida, así
    que no hay ambigüedad posible.

    ⚠️ CON "TODOS" NO HAY PAGINACIÓN

    Y eso es peligroso con muchos registros: el navegador renderiza
    todas las filas de golpe. Por eso el infinito muestra un aviso
    cuando el total supera `warnAbove`.
*/

export const PER_PAGE_OPTIONS = [
    { value: 6, label: '6' },
    { value: 12, label: '12' },
    { value: 25, label: '25' },
    { value: -1, label: <TiInfinity size={20} />, title: 'Mostrar todos' },
];

export const TablePerPage = ({
    value = 12,
    onChange,
    options = PER_PAGE_OPTIONS,
    totalItems = 0,
    warnAbove = 500,
    label = 'Mostrar',
}) => {

    const IS_ALL = Number(value) === -1;

    const IS_HEAVY = IS_ALL && totalItems > warnAbove;

    return (
        <div className={`${BLOCK}__perpage`}>

            {label && <span className={`${BLOCK}__perpage_label`}>{label}</span>}

            <div className={`${BLOCK}__perpage_group`} role="group" aria-label="Registros por página">
                {
                    options.map((opt) => (
                        <button key={opt.value} type="button"
                            className={`${BLOCK}__perpage_option`}
                            data-on={Number(value) === Number(opt.value)}
                            title={opt.isDisabled ? 'No hay tantos registros' : (opt.title ?? `Mostrar ${opt.label}`)}
                            aria-pressed={Number(value) === Number(opt.value)}
                            disabled={!!opt.isDisabled}
                            onClick={() => onChange?.(Number(opt.value))} >
                            {opt.label}
                        </button>
                    ))
                }
            </div>

            {
                IS_HEAVY && (
                    <span className={`${BLOCK}__perpage_warn`}
                        title={`Mostrar ${totalItems} filas de una vez puede ralentizar el navegador`} >
                        {totalItems} filas
                    </span>
                )
            }

        </div>
    );
};
